import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Row,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  ButtonDropdown,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  Label,
  Input,
  Badge,
} from "reactstrap";
import Widget from "../../components/Widget/Widget.js";
import SearchIcon from "../../components/Icons/HeaderIcons/SearchBarIcon.js"
import { format } from 'date-fns';

// import BootstrapTable from "react-bootstrap-table-next";
// import paginationFactory from 'react-bootstrap-table2-paginator';
// import MUIDataTable from "mui-datatables";
import moreIcon from "../../assets/tables/moreIcon.svg"; //

import s from "../tables/Tables.module.scss";


import { css } from "@emotion/react";
import { ClockLoader } from "react-spinners";
import BaseAPI from '../../api/apiurl.js';
import Select from "react-select";
import DatePicker from 'react-datepicker';

import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FaCalendar } from 'react-icons/fa';
import '../subpages/datepicker.css';



const ProjectCompleted = function () {



  const [secondTableCurrentPage, setSecondTableCurrentPage] = useState(0); //
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");



  const pageSize = 10;
const secondTablePagesCount = Math.ceil((data && data.length) ? data.length / pageSize : 0);


  const setSecondTablePage = (e, index) => {
    e.preventDefault();
    setSecondTableCurrentPage(index);
  }

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredData = data.filter(
    (item) =>
      (item.entityname && item.entityname.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item.entitydesc && item.entitydesc.toLowerCase().includes(searchTerm.toLowerCase())) ||
      ((item.AssignDesc && item.AssignDesc.toLowerCase().includes(searchTerm.toLowerCase())) || item.AssignDesc === null) ||
      (item.departName && item.departName.toLowerCase().includes(searchTerm.toLowerCase()))
  );
  
  
  

  const fetchData = () => {
    const customerId = localStorage.getItem('customerid');
    const companyId = localStorage.getItem('companyid');
    const url = `${BaseAPI}projectfilters?company_id=${companyId}&customer_id=${customerId}&status=2`;
  
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (data.data && data.data.length > 0) {
          setData(data.data);
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching data from API:', error);
      });
  };
  
  

  
  useEffect(() => {
    const loadingTimeout = setTimeout(() => {
      setIsLoading(false);
      fetchData();
      const combinedData =  filteredData || data;
    }, 2000);

    return () => clearTimeout(loadingTimeout);
  }, []);

 
  return (
    <div>
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
          <ClockLoader color={"#4e73df"} loading={isLoading} css={spinnerStyle} size={100} />
        </div>
      ) : (
        <div>
          <br/>
          <Row>
            <Col>
              <Row className="mb-4">
                <Col>
                  <Widget>
                  <div style={{ padding: "20px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
  <div style={{ display: "flex", alignItems: "center" }}>
     <div className="headline-2" style={{color : "blue"}}>Project Completed</div>
  </div>
  <div style={{ display: "flex", alignItems: "center" }}>
    <div className="col-sm-40 input-group">
    <Input
  type="text"
  id="searchUser"
  placeholder="Search..."
  value={searchTerm}
  onChange={handleSearch} 
  style={{ width: '150px' }}
  className="focus form-control custom-input-group-text" 
/>

      <div className="input-group-append">
        <span className="password-toggle input-group-text" > <SearchIcon /></span>
      </div>
    </div>
  </div>
</div>

                    <div className="widget-table-overflow">
                      <Table className="table-striped table-borderless table-hover" responsive>
                      <thead>
                          <tr style={{ whiteSpace: 'nowrap' }}>
                            <th>Customer</th>
                            <th>Project Name</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Location</th>
                            <th>Department</th>
                            <th>Users(s)</th>
                            <th>Tasks</th>
                            <th>Status</th>
                          </tr>
                        </thead>  
                        <tbody>
                        {filteredData && filteredData.length > 0 ? (
  filteredData
    .slice(secondTableCurrentPage * pageSize, (secondTableCurrentPage + 1) * pageSize)
    .map((item, index) => (
                            <tr key={index.id}>
                              <td>{item.entitydesc}</td>
                              <td>{item.entityname}</td>
                              <td>{item.startdate}</td>
                              <td>{item.enddate}</td>
                              <td>{item.AssignDesc}</td>
                              <td>{item.departName}</td>
                              <td>{item.staffestimated}</td>
                              <td>{item.totaltasks}</td>
                              {/* <td>{item.status}</td> */}
                              <td><Badge style={{
                                          backgroundColor:
                                            
                                         
                                                item.status === 'Planned' ? 'blue' :
                                                  item.status === 'Completed' ? 'Green' :
                                                  item.status === 'In Progress' ? 'indigo' :
                                                  item.status === 'Cancelled' ? 'gray' : 'black',
                                          color: item.status === '' ? 'black' : 'white',
                                        }}>{item.status}</Badge>
                             </td>
                            </tr>
                          ))
                          ) : (
                            <tr>
                              <td colSpan="9" style={{ textAlign: "center", color: "red" }}>
                                No data available
                              </td>
                            </tr>
                          )}

                        </tbody>
                      
                      </Table>
                      <Pagination className="pagination-with-border">
                        <PaginationItem disabled={secondTableCurrentPage <= 0}>
                          <PaginationLink
                            onClick={e => setSecondTablePage(e, secondTableCurrentPage - 1)}
                            previous
                            href="#top"
                          />
                        </PaginationItem>
                        {[...Array(secondTablePagesCount)].map((page, i) =>
                          <PaginationItem active={i === secondTableCurrentPage} key={i}>
                            <PaginationLink onClick={e => setSecondTablePage(e, i)} href="#top">
                              {i + 1}
                            </PaginationLink>
                          </PaginationItem>
                        )}
                        <PaginationItem disabled={secondTableCurrentPage >= secondTablePagesCount - 1}>
                          <PaginationLink
                            onClick={e => setSecondTablePage(e, secondTableCurrentPage + 1)}
                            next
                            href="#top"
                          />
                        </PaginationItem>
                      </Pagination>
                    </div>
                  </Widget>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      )}
    </div>
  )
}
const spinnerStyle = css`
display: block;
margin: 0 auto;
`;

export default ProjectCompleted;
